import { useCallback } from "react";
import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";

const channelId = uuid();

export function useBroadcastChannel(channelName, handler) {
  const [broadcastChannel] = useState(new BroadcastChannel(channelName));

  useEffect(() => {
    broadcastChannel.onmessage = (event) => {
      const { channelId: _channelId, ...message } = event.data;
      handler && channelId !== _channelId && handler(message);
    };
  }, []);

  return useCallback(
    (message) => {
      return broadcastChannel?.postMessage({
        channelId,
        message,
      });
    },
    [channelName, broadcastChannel]
  );
}
